import createSelector from 'selectorator';

import type { VCSState } from './types';

// state is the entire redux state (unsure of the type, and it's not necessarily that important here)
const getCurrentInstanceData = (state: any) => {
  const vcsState: VCSState = state?.vcs;

  return vcsState?.instanceData?.[vcsState?.query?.instanceName || ''];
};

const vcsSelectors = {
  getStatus: createSelector(['vcs.status'], status => status),
  getImportStatus: createSelector(['vcs.importStatus'], status => status),
  getInstances: createSelector(['vcs.instances'], data => data),
  getQueryParameters: createSelector(['vcs.query'], data => data),
  getFilters: createSelector([getCurrentInstanceData], instanceData => instanceData?.filters || []),
  getRepositories: createSelector([getCurrentInstanceData], instanceData => instanceData?.repositories || []),
  getSelectedRepositories:
    createSelector([getCurrentInstanceData], instanceData => instanceData?.selectedRepositories || []),
  getIsConnected: createSelector([getCurrentInstanceData], instanceData => instanceData?.connected || false),
  getIsPrivateAccess: createSelector([getCurrentInstanceData], instanceData => instanceData?.privateAccess || false),
};

export default vcsSelectors;
